/** Clamp discovery relevance to 1-5 for display. */
export function normalizeRelevanceLevel(relevance) {
  const value = Number(relevance);
  if (!Number.isFinite(value)) return 1;
  return Math.min(5, Math.max(1, Math.round(value)));
}

export function getRelevanceChipProps(relevance) {
  const level = normalizeRelevanceLevel(relevance);

  return {
    level,
    label: `${level >= 5 ? 'Best Match' : level >= 4 ? 'Strong Match' : level >= 3 ? 'Related' : 'Low Relevance'} - ${level}/5`,
    explanation: `${level}/5 task fit: ${['unrelated to the request', 'weak connection to the request', 'related outcome, but the task or details need clarification', 'strong match for the requested task', 'directly fulfills the requested outcome'][level - 1]}. This is separate from build quality.`,
    sx: {
      flexShrink: 0,
      height: 22,
      fontSize: '0.6875rem',
      fontWeight: 500,
      borderRadius: 999,
      border: '1px solid',
      borderColor: 'rgba(100, 116, 139, 0.18)',
      bgcolor: 'rgba(100, 116, 139, 0.05)',
      color: 'rgb(100, 116, 139)',
      '& .MuiChip-label': {
        px: 0.875,
      },
    },
  };
}

export function getQualityEvidenceChipProps(quality, { uses = 0 } = {}) {
  const signals = Array.isArray(quality?.signals) ? quality.signals : [];
  const usageCount = Number(uses || 0);
  let label = null;

  if (signals.includes('evidence of reuse') && usageCount > 0) {
    label = `Used ${usageCount} ${usageCount === 1 ? 'time' : 'times'}`;
  } else if (signals.includes('recently maintained')) {
    label = 'Recently updated';
  } else if (signals.includes('supporting knowledge attached')) {
    label = 'Includes knowledge';
  }

  if (!label) return null;

  return {
    label,
    sx: {
      flexShrink: 0,
      height: 22,
      fontSize: '0.6875rem',
      fontWeight: 650,
      letterSpacing: '0.01em',
      borderRadius: 999,
      border: '1px solid rgba(100, 116, 139, 0.18)',
      bgcolor: 'rgba(100, 116, 139, 0.06)',
      color: '#475569',
      '& .MuiChip-label': { px: 0.875 },
    },
  };
}

export function getRecommendationTierLabel(relevance) {
  const level = normalizeRelevanceLevel(relevance);
  if (level >= 4) return 'Strong Matches';
  if (level === 3) return 'Relevant Matches';
  return 'Low Relevance';
}

export function filterVisibleDiscoveryResults(results = []) {
  const relevant = results.filter((result) => normalizeRelevanceLevel(result.relevance) >= 3);
  const excellent = relevant.filter((result) => normalizeRelevanceLevel(result.relevance) > 4);
  return excellent.length > 3 ? excellent : relevant;
}

export function filterVisibleKnowledgeResults(results = []) {
  return results.filter((result) => Number(result.relevance) >= 4)
    .sort((a, b) => Number(b.relevance) - Number(a.relevance)).slice(0, 3);
}

export function pickPrimaryDiscoveryResult(results = []) {
  if (!results.length) return null;
  return results[0];
}
